import React, { useState } from 'react'
import { firestore } from '../../../firebase';

function AddChoice({quizId, questionId}) {
    
    const [choice, setChoice] = useState("");
    const [isCorrect, setIsCorrect] = useState(false);
    const [error, setError] = useState("");

    async function addChoiceHandler(e) {
        e.preventDefault();
        try {
            const choiceRef = firestore.collection("quiz").doc(quizId).collection("questions").doc(questionId).collection("choices");
            const data = {
                choice,
                is_correct: Boolean(isCorrect)
            }
            choiceRef.add(data)
        } catch (error) {
            setError("Kunne ikke legge til");
        }
    }
    
    return (

        <form onSubmit={addChoiceHandler}>

            <label>Valg</label>
            <input className="form-control mb-2" value={choice} onChange={e => setChoice(e.target.value)} placeholder="Valgtekst" />

            <label>Spørsmål korrekt? {isCorrect ? "True" : "False"}</label>
            <select className="form-control mb-2" onChange={e => setIsCorrect(e.target.value)}>
                <option>Velg korrekt eller ukorrekt:</option>
                <option value={true}>Korrekt</option>
                <option value="">Ikke korrekt</option>
            </select>

            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-success btn-block">Legg til valg</button>
        </form>

    )
}
export default AddChoice